import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import { useShiftStore } from './stores/shiftStore';
import { useRealtimeUpdates } from './hooks/useRealtimeUpdates';
import LoginPage from './pages/LoginPage';
import ShiftTypeSelectPage from './pages/ShiftTypeSelectPage';
import PreShiftPage from './pages/PreShiftPage';
import PostShiftPage from './pages/PostShiftPage';
import TablesPage from './pages/TablesPage';
import OrderPage from './pages/OrderPage';
import CheckoutPage from './pages/CheckoutPage';
import FeedbackPage from './pages/FeedbackPage';
import Layout from './components/Layout';
import ShiftGuard from './components/ShiftGuard';

export default function App() {
  const { isAuthenticated } = useAuthStore();
  const { status: shiftStatus } = useShiftStore();

  // Real-time updates (WebSocket). Purely a nice-to-have on top of polling —
  // it reconnects quietly in the background and never surfaces a banner.
  useRealtimeUpdates();

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // Handle shift-based routing
  // Shift type selection - full screen after login, before clock-in
  if (shiftStatus === 'no_shift' || shiftStatus === 'selecting_shift_type') {
    return (
      <Routes>
        <Route path="/shift-type" element={<ShiftTypeSelectPage />} />
        <Route path="*" element={<Navigate to="/shift-type" replace />} />
      </Routes>
    );
  }

  // Pre-shift checklist - full screen (no Layout)
  if (shiftStatus === 'pre_shift') {
    return (
      <Routes>
        <Route path="/pre-shift" element={<PreShiftPage />} />
        <Route path="*" element={<Navigate to="/pre-shift" replace />} />
      </Routes>
    );
  }

  if (shiftStatus === 'post_shift') {
    return (
      <Routes>
        <Route path="/post-shift" element={<PostShiftPage />} />
        <Route path="*" element={<Navigate to="/post-shift" replace />} />
      </Routes>
    );
  }

  // Active shift - show main app with Layout
  return (
    <>
      <Layout>
        <ShiftGuard>
          <Routes>
            <Route path="/" element={<Navigate to="/tables" replace />} />
            <Route path="/tables" element={<TablesPage />} />
            <Route path="/order/:tableId" element={<OrderPage />} />
            <Route path="/order/:tableId/checkout" element={<CheckoutPage />} />
            <Route path="/feedback/:checkId" element={<FeedbackPage />} />
            <Route path="/post-shift" element={<Navigate to="/tables" replace />} />
            <Route path="*" element={<Navigate to="/tables" replace />} />
          </Routes>
        </ShiftGuard>
      </Layout>
    </>
  );
}
